export class PeopleSlickSlider {
	constructor(node) {
		this.node = node;
		this.images = node.querySelector(".people-slider__images");
		this.details = node.querySelector(".people-slider__details");

		if (!this.images || !this.details) return;

		this.slideCount = this.images.children.length;
		this.initSlider();
		this.observeVisibility();
	}

	initSlider() {
		// centerMode + infinite need real slides to clone into a loop. When
		// there aren't more people than fit on screen at once, Slick pads
		// the track with extra copies of the same slides to make the loop
		// math work, which shows up as duplicated photos. Only loop when
		// there's actually more than one screen's worth to scroll through.
		const canLoop = this.slideCount > 4;
		const slidesToShow = Math.min(4, this.slideCount);

		jQuery(document).ready(() => {
			jQuery(this.images).slick({
				slidesToShow,
				slidesToScroll: 1,
				asNavFor: this.details,
				dots: true,
				centerMode: true,
				centerPadding: "0px",
				infinite: canLoop,
				variableWidth: true,
				rows: 0,
				responsive: [
					{
						breakpoint: 781,
						settings: {
							slidesToShow: Math.min(2, slidesToShow),
							centerPadding: "30px",
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
							centerPadding: "20px",
						},
					},
				],
			});

			jQuery(this.details).slick({
				arrows: false,
				infinite: canLoop,
				asNavFor: this.images,
			});

			// accessible-slick dropped `focusOnSelect` (it only warns if you
			// pass it), so clicking a photo to select it has to be wired up
			// by hand via the public slickGoTo API instead. Delegate from
			// the container rather than binding on individual `.slick-slide`
			// elements, since Slick rebuilds that markup on init/breakpoint
			// changes and clones slides for infinite-loop mode.
			jQuery(this.images).on("click", ".slick-slide", (event) => {
				const index = parseInt(
					event.currentTarget.getAttribute("data-slick-index"),
					10,
				);

				if (!Number.isNaN(index)) {
					jQuery(this.images).slick("slickGoTo", index);
				}
			});
		});
	}

	/**
	 * Slick measures slide widths against the container at init time. If
	 * this slider starts out inside a hidden tab panel (or anything else
	 * with display:none, e.g. waepa/tabs hides every panel but the first),
	 * it initializes against a zero-width container and stays broken even
	 * after the panel becomes visible. Watch the node's real size and ask
	 * Slick to recompute whenever it changes, instead of assuming anything
	 * about what's hiding it.
	 *
	 * Slick also has its own window-resize handling that runs regardless of
	 * this node's visibility. If the browser is resized while this slider
	 * sits in an inactive tab, that handler still fires and recalculates
	 * slide positions against the hidden (zero-width) container, baking in
	 * wrong offsets. When the tab is reactivated, the container's real width
	 * often matches whatever `lastWidth` was before it got hidden, so a
	 * plain width comparison would wrongly treat it as "unchanged" and skip
	 * the recompute needed to undo that corruption. Track whether the node
	 * was hidden and force a recompute on reveal regardless of whether the
	 * width happens to match the previous value.
	 */
	observeVisibility() {
		let lastWidth = this.node.offsetWidth;

		const observer = new ResizeObserver(() => {
			const width = this.node.offsetWidth;

			if (!width) {
				lastWidth = 0;
				return;
			}

			const wasHidden = lastWidth === 0;
			if (width === lastWidth && !wasHidden) return;
			lastWidth = width;

			[this.images, this.details].forEach((el) => {
				if (jQuery(el).hasClass("slick-initialized")) {
					jQuery(el).slick("setPosition");
				}
			});
		});

		observer.observe(this.node);
	}
}

document.addEventListener("DOMContentLoaded", () => {
	jQuery(document).ready(() => {
		document.querySelectorAll(".people-slider-slick").forEach((node) => {
			new PeopleSlickSlider(node);
		});
	});
});
